import Vue from 'vue';
import _ from 'underscore';
import Router from 'vue-router';
import { Auth } from '@aws-amplify/auth';
import {EntityCreate, EntityEdit, EntityExport, EntityHome, EntityImport, EventRegexCreate, EventRegexHome, EventRegexEdit, ImportsHome, ImportView, OrphanedSearches, Profile, SearchUpdate, SearchCreate, SearchEdit, SearchesHome, UbermetricsAccountCountings, TagChange} from '@/components';
import Login from '@/components/Login';
import AmplifyStore from '../store/store';


Vue.use(Router);

let user;

function getUser() {
  return Auth.currentAuthenticatedUser().then(function (data) {
    if (data && data.signInUserSession) {
      AmplifyStore.commit('setUser', data);
      return data;
    }
  }).catch(function (e) {
    AmplifyStore.commit('setUser', null);
    return null;
  });
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/entity/create',
      name: 'entity_create',
      component: EntityCreate,
      meta: {requiresAuth: true},
    },
    {
      path: '/entity/import',
      name: 'entity_import',
      component: EntityImport,
      meta: {
        requiresAuth: true,
        allowedGroups: ['becketal'],
      },
    },
    {
      path: '/entity/tagchange',
      name: 'tag_change',
      component: TagChange,
      meta: {
        requiresAuth: true,
        allowedGroups: ['becketal'],
      },
    },
    {
      path: '/entity/export',
      name: 'entity_export',
      component: EntityExport,
      meta: {requiresAuth: true},
    },
    {
      path: '/entity/:uuid',
      name: 'entity_details',
      component: EntityEdit,
      meta: {requiresAuth: true},
    },
    {
      path: '/ubermetrics-searches',
      name: 'ubermetrics_searches',
      component: SearchesHome,
      meta: {requiresAuth: true},
    },
    {
      path: '/ubermetrics-searches/create',
      name: 'ubermetrics_searches_create',
      component: SearchCreate,
      meta: {requiresAuth: true},
    },
    {
      path: '/ubermetrics-searches/:id',
      name: 'ubermetrics_search_edit',
      component: SearchEdit,
      meta: {
        requiresAuth: true,
        allowedGroups: ['becketal'],
      },
    },
    {
      path: '/event-regex',
      name: 'event_regex',
      component: EventRegexHome,
      meta: {
        requiresAuth: true,
        allowedGroups: ['becketal'],
      },
    },
    {
      path: '/event-regex/create',
      name: 'event_regex_create',
      component: EventRegexCreate,
      meta: {
        requiresAuth: true,
        allowedGroups: ['becketal'],
      },
    },
    {
      path: '/searchupdate',
      name: 'search_update',
      component: SearchUpdate,
      meta: {requiresAuth: true},
    },
    {
      path: '/event-regex/:id',
      name: 'event_regex_edit',
      component: EventRegexEdit,
      meta: {
        requiresAuth: true,
        allowedGroups: ['becketal'],
      },
    },
    {
      path: '/ubermetrics-metrics',
      name: 'ubermetrics_metrics',
      component: UbermetricsAccountCountings,
      meta: {requiresAuth: true},
    },
    {
      path: '/orphaned-searches',
      name: 'orphaned_searches',
      component: OrphanedSearches,
      meta: {requiresAuth: true},
    },
    {
      path: '/imports',
      name: 'imports',
      component: ImportsHome,
      meta: {requiresAuth: true},
    },
    {
      path: '/imports/:id',
      name: 'import_view',
      component: ImportView,
      meta: {requiresAuth: true},
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {requiresAuth: true},
    },
    {
      path: '/auth',
      name: 'Authenticator',
      component: Login,
    },
    {
      path: '/',
      name: 'entity_list',
      component: EntityHome,
      meta: {requiresAuth: true},
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
});

router.beforeResolve(async (to, from, next) => {

  console.info(to.fullPath);

  if (to.matched.some(record => record.meta.requiresAuth)) {

    user = await getUser();

    if (!user) {
      return next({
        path: '/auth',
        query: {
          redirect: to.fullPath,
        },
      });
    }

    // get groups for user and check against potential route-groups
    let usersGroups = user.signInUserSession.idToken.payload['cognito:groups'];
    if (!_.isEmpty(to.meta.allowedGroups) && _.isEmpty(_.intersection(usersGroups, to.meta.allowedGroups))) {
      console.info('not allowed to access this path');
      return next({
        path: '/',
        query: {
          redirect: to.fullPath,
        },
      });
    }
    return next();
  }
  return next();
});

export default router;
